module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-11.b46526bb.png";